import React from "react";

import { useTranslations } from "next-intl";

import { Link } from "@/i18n/routing";
import { cn } from "@/utils/cn";
import { removeLocalePrefix } from "@/utils/urlHelpers";

interface ObjectDetailDeveloperProps {
  name: string;
  href?: string;
  className?: string;
}

export const ObjectDetailDeveloper: React.FC<ObjectDetailDeveloperProps> = ({
  name,
  href,
  className,
}) => {
  const t = useTranslations();

  return (
    <p className={cn("text-[1.5rem]", className)}>
      <span className="text-gray-1200">{`${t("Developer")}: `}</span>
      {href ? (
        <Link
          href={removeLocalePrefix(href)}
          className="link font-bold text-dark"
        >
          {name}
        </Link>
      ) : (
        <span className="font-bold text-dark">{name}</span>
      )}
    </p>
  );
};
